import styled from 'styled-components';
import { Paper } from '@cashfree-intl/coherent';

export const StyledBanner = styled.div`
  margin-bottom: 1.75rem;
`;

export const StyledImportUnsettledAmountPaper = styled(Paper)`
  width: fit-content;
`;

export const StyledNextSettlementsAmountCard = styled(Paper)`
  min-width: 23rem;
  max-width: 36rem;

  .footer {
    background-color: ${props => props.theme.COLORS.warningBg};
  }
`;
